<ca-tooltip>
    <div class="aqi-details-tooltip">
        <span [innerHtml]="TEXTS.AQI_DETAILED_INFO.tooltip"></span>&nbsp;
        <a class="aqi-details-tooltip-link" (click)="openDetails($event)">
            {{ TEXTS.AQI_DETAILED_INFO.gotoFAQ }}
        </a>
    </div>
</ca-tooltip>
